import { useTranslation } from 'react-i18next';

import type { FieldValues } from 'react-hook-form';
import type IErrorMessage from '../store/types/IErrorMessage';
import type { IUseFieldsErrors } from './interfaces/IUseFieldsErrors';

const useFieldsErrors = () => {
  const { t } = useTranslation();

  const setFieldsErrors = <T extends FieldValues>({ errors, setError, fieldsName }: IUseFieldsErrors<T>): boolean => {
    let hasMappedFieldError = false;

    errors?.data?.message?.forEach((fieldErrors: IErrorMessage<T>[]) => {
      fieldErrors?.forEach((error) => {
        const property = error.property.replace('.', '_');
        const isFieldNameExist = fieldsName?.includes(property);
        if (isFieldNameExist) {
          // The BE can flag a field without a usable message. Fields highlight on the message
          // being truthy, so without a fallback the error is invisible and the mapping still
          // suppresses the caller's toast.
          const message = typeof error.error === 'string' ? error.error.trim() : '';
          setError(property, { message: message || t('common.unknownError') });
          hasMappedFieldError = true;
        }
      });
    });

    return hasMappedFieldError;
  };

  return { setFieldsErrors };
};

export default useFieldsErrors;
